import request from '@/utils/request'

// 查询报告录入模板列表
export function listReportTemplate(query) {
    return request({
        url: '/biz/reportTemplate/list',
        method: 'get',
        params: query
    })
}
export function searchListReportTemplate(query) {
    return request({
        url: '/biz/reportTemplate/searchListReportTemplate',
        method: 'get',
        params: query
    })
}

// 查询报告录入模板详细
export function getReportTemplate(id) {
    return request({
        url: '/biz/reportTemplate/' + id,
        method: 'get'
    })
}

// 新增报告录入模板
export function addReportTemplate(data) {
    return request({
        url: '/biz/reportTemplate',
        method: 'post',
        data: data
    })
}

// 修改报告录入模板
export function updateReportTemplate(data) {
    return request({
        url: '/biz/reportTemplate/update',
        method: 'post',
        data: data
    })
}

// 删除报告录入模板
export function delReportTemplate(id) {
    return request({
        url: '/biz/reportTemplate/delete/' + id,
        method: 'post'
    })
}
